import {PublicClientApplication} from "@azure/msal-browser";

import {InitialRequestUrl} from "@khan/shared-core";

import {getClientId, getRedirectUri} from "./config.ts";

export function createPublicClientApplication() {
    return new PublicClientApplication({
        auth: {
            clientId: getClientId(),
            authority: `https://login.microsoftonline.com/common`,
            redirectUri: getRedirectUri(InitialRequestUrl.hostname),
        },
    });
}
